export default "__VITE_ASSET__f4dd5196__"